// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"f2ada074","107":"256a54f5","239":"ad40150f","455":"585d749f","977":"6a7f6471"}[chunkId] + ".chunk.js";
};